import PropertiesPage from './PropertiesPage';

export default PropertiesPage;
